import { useMemo } from 'react';

import { ICountryAndDialCode } from '@aqx-core/common/api/account';
import { getCountryLabelFromSelectedCountry } from '@aqx-core/common/format/country';

export interface ICountryOption {
  label: string;
  value: string;
  testID?: string;
}

export const useCountryOptions = (countries: ICountryAndDialCode[]): ICountryOption[] => {
  return useMemo(() => {
    return countries.map(({ country, countryCode }) => ({
      label: getCountryLabelFromSelectedCountry({ country, countryCode }),
      value: countryCode,
      testID: countryCode
    }));
  }, [countries]);
};
